<template lang="pug">
  component(:is="flaggedComponent" v-bind="$props" v-on="$attrs")
</template>

<script>
import BuildingKitAiTestingOld from './BuildingKitAiTestingOld.vue';
import BuildingKitAiTestingNew from './BuildingKitAiTestingNew.vue';
import { mapState } from 'vuex';

export default {
  name: 'BuildingKitAiTestingWrapper',
  components: {
    BuildingKitAiTestingOld,
    BuildingKitAiTestingNew,
  },
  computed: {
    ...mapState({
      featureFlags: state => state.featureFlags.FEATURE_FLAGS,
    }),
    flaggedComponent() {
      return this.featureFlags?.SHOW_NEW_INTENT_DESIGN ? BuildingKitAiTestingNew : BuildingKitAiTestingOld;
    },
  },
};
</script>
